import { snippetTypes, usersTypes } from '../../types';

const defaultState = {
  personalSnippets: [],
  sharedSnippets: []
};

const map = {
  [snippetTypes.SET_SNIPPETS]: (state, action) => ({
    ...state,
    ...action.payload.data
  }),
  [usersTypes.SWITCH_WORKSPACE]: () => defaultState
};

export default (state = defaultState, action) =>
  (map[action.type] && map[action.type](state, action)) || state;
